import MedicationsFilterModal from "./MedicationsFilterModal";

export default MedicationsFilterModal;
export * from "./MedicationsFilterModal";
